// src/pages/Streaming/StreamingService.js

import ApiService from "../../services/api-service";

class StreamingService {
  /**
   * Start a livestream.
   * Merges user-specified fields with defaults for required fields.
   */
  static async startLiveStream(payload) {
    try {
      // Merge your original payload with mandatory fields
      // (platform = "hedera", isNew = true)
      const finalPayload = {
        ...payload,
        platform: "web",
        isNew: true,
      };

      console.log("Start Live Stream with finalPayload:", finalPayload);

      // Call your back-end API
      const response = await ApiService.LIVESTART(finalPayload);

      // The back end returns { status, code, message, result } at top level
      if (response?.status !== "success" || !response?.result) {
        throw new Error("Missing 'result' in API response");
      }

      // Return a standardized object
      return {
        success: true,
        data: response.result, // e.g., { token, channelName, appId, etc. }
      };
    } catch (error) {
      console.error("Error starting livestream:", error);
      return {
        success: false,
        message: error?.response?.data?.message || error?.message || "Failed to start livestream",
      };
    }
  }

  // Join a livestream

  static async joinLiveStream(payload) {
    try {
      // Call your back-end API
      const response = await ApiService.LIVEJOIN(payload);
  
      // Check in `response.result` for token/channel:
      if (
        response?.status === "success" &&
        response?.result?.token &&
        response?.result?.channelName
      ) {
        return {
          success: true,
          data: response.result, 
        };
      } else {
        throw new Error("No token or channelName in server response");
      }
    } catch (error) {
      console.error("Error joining livestream:", error);
      return {
        success: false,
        message: "Failed to join livestream",
      };
    }
  }

  static async exitLiveStream(payload) {
    try {
      console.log("Exit Live Stream with payload:", payload);
  
      const response = await ApiService.LIVEEXIT(payload);
  
      if (response?.status !== "success" || !response?.result) {
        throw new Error("No result returned from API");
      }
  
      return {
        success: true,
        data: response.result,
      };
    } catch (error) {
      console.error("Error exiting livestream:", error);
      return {
        success: false,
        message: "Failed to exit livestream",
      };
    }
  }
  
  
  

  /**
   * End a livestream.
   */
  static async endLiveStream(channelName) {
    try {
      console.log("End Live Stream with channelName:", channelName);

      const response = await ApiService.LIVEEND({ channelName });

      if (response?.status !== "success" || !response?.result) {
        throw new Error("No result returned from API");
      }

      return {
        success: true,
        data: response.result,
      };
    } catch (error) {
      console.error("Error ending livestream:", error);
      return {
        success: false,
        message: "Failed to end livestream",
      };
    }
  }
}

export default StreamingService;
